export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3002/api";

export const API_PATHS = {
  AUTH: {
    REGISTER: "/auth/register",
    VERIFY_OTP: "/auth/verify-otp",
    RESEND_OTP: "/auth/resend-otp",
    LOGIN: "/auth/login",
    FORGOT_PASSWORD: "/auth/forgot-password",
    RESET_PASSWORD: "/auth/reset-password",
    LOGOUT: "/auth/logout",
    PROFILE: "/auth/profile",
  },
  BILLING: {
    PLANS: "/billing/plans",
    SUBSCRIPTION: "/billing/subscription",
    PENDING_CHANGE: "/billing/pending-change",
    CHECKOUT_SESSION: "/billing/checkout-session",
    PORTAL_SESSION: "/billing/portal-session",
    RESUME: "/billing/resume",
    UPGRADE: "/billing/upgrade",
    DOWNGRADE: "/billing/downgrade",
    ADDONS: "/billing/addons",
    ADDONS_PREVIEW: "/billing/addons/preview",
    SYNC: "/billing/sync",
  },
  USERS: {
    ME: "/users/me",
    ICON: "/users/me/icon",
    PASSWORD: "/users/me/password",
    EMAIL: "/users/me/email",
    EMAIL_VERIFY: "/users/me/email/verify",
  },
  SYSTEM: {
    CONTACT: "/system/contact",
  },
};
